<template>
    <div class="entrance-wrap">
        <div class="head-text">
            <span class="f13 font-weight-bold">Videos</span>
            <router-link :to="{name: 'video', params: {id: 1}}" class="more-btn">More>></router-link>
        </div>
        <!--    <div class="list">-->
        <ul class="row">
            <li v-for="(item, index) in value" :key="index" @click="change(item)" class="col-md-4 cursor"
                :class="{'pl-0': index / 2 === 0 && index !==0 }">
                <div class="img-cell">
                    <img :src="item.imgUrl" alt="">
                </div>
                <div class="title-message">
                    <p>{{item.title}}</p>
                    <!-- <p>{{item.time}}</p> -->
                </div>
            </li>
        </ul>
        <!--    </div>-->
    </div>
</template>

<script>
export default {
  name: 'serviceEntrance',
  props: {
    value: Array
  },
  data () {
    return {}
  },
  methods: {
    change (val) {
      this.$emit('gotoService', val)
    }
  }
}
</script>

<style scoped lang="less">
    @media screen and (min-width: 767px) {
        .row {
            height: calc(100% - 60px);
            overflow: auto;
        }
    }

    .entrance-wrap {
        width: 100%;

        .head-text {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 42px;
            margin: 10px 0 11px 23px;
            padding-right: 11px;
            border-bottom: 2px solid #E4E7ED;

            span {
                color: #409EFF;
            }

            .more-btn {
                color: #0078FF !important;
                border-left: 0;
                background: transparent;
            }
        }

        .row {
            display: flex;
            width: 100%;
            padding: 0 10px;
            flex-wrap: wrap;
            // height: calc(100% - 42px);
            margin: 0 !important;
            // padding-left: 0;
        }

        li {
            width: 50%;
            // height: calc(100% - 12px);
            text-align: center;
            margin-top: 6px;

            .img-cell {
                position: relative;
                width: 100%;
                height: 0;
                padding-bottom: 60%;

                img {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            .title-message {
                height: 32px;
                line-height: 14px;
                margin-top: 4px;
                font-size: 12px;

                p {
                    &:nth-child(1) {
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2; /*超出3行部分显示省略号，去掉该属性 显示全部*/
                        -webkit-box-orient: vertical;
                    }
                }
            }
        }

        .col-md-4 {
            padding-right: 5px;
            padding-left: 5px;
        }
    }
</style>
